var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { WebPlugin } from '@capacitor/core';
import axios from "axios";
export class TuerPluginWeb extends WebPlugin {
    constructor() {
        super({
            name: 'TuerPlugin',
            platforms: ['web']
        });
    }
    echo(options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (options.mode == "platform") {
                return { value: "web" };
            }
            let url = options.value;
            if (options.mode == "find") {
                url = "https://indie42.de/dist/feedfinder.php?q=" + url;
            }
            if (options.mode == "echo") {
                url = "https://indie42.de/dist/echo.php?q=" + url;
            }
            if (options.mode == "parse") {
                url = "https://indie42.de/dist/news.php?v=2&i=1&q=" + url;
            }
            let response = yield axios.get(url);
            return { value: response.data };
        });
    }
}
const TuerPlugin = new TuerPluginWeb();
export { TuerPlugin };
import { registerWebPlugin } from '@capacitor/core';
registerWebPlugin(TuerPlugin);
//# sourceMappingURL=web.js.map